import React from 'react'
import propTypes from 'prop-types'
import {isWhite} from 'helpers/ui'
import themeVars from 'theme/themeVars'

const ColorStatus = (props) => {
  const {backgroundColor, marginRight} = props

  const getBorder = (backgroundColor) => {
    if (isWhite(backgroundColor))
      return `1px solid ${themeVars.palette.borderColor}`
    else
      return '1px solid transparent'
  }

  return (
      <div
          className={'status'}
          style={{
            backgroundColor,
            borderRadius: '50%',
            marginRight: marginRight,
            height: '12px',
            width: '12px',
            flexShrink: 0,
            border: getBorder(backgroundColor),
          }}/>
  )
}

ColorStatus.propTypes = {
  backgroundColor: propTypes.string.isRequired,
  marginRight: propTypes.oneOfType([
    propTypes.number,
    propTypes.string,
  ]),
}

ColorStatus.defaultProps = {
  marginRight: '12px',
}

export default ColorStatus
